<template>
  <el-input
    v-model="inputValue"
    :disabled="disabled"
    :placeholder="placeholder"
    :clearable="clearable"
    :show-password="showPassword"
    :type="type"
    :show-word-limit="$attrs['show-word-limit']"
    :minlength="minlength"
    :maxlength="maxlength"
    :prefix-icon="prefixIcon"
    :suffix-icon="suffixIcon"
    :rows="rows"
    :autosize="autosize"
    :size="size"
    v-bind="$attrs"
    @input="inputChange"
    @change="handleChange"
    @blur="handleBlur"
    @focus="handleFocus"
    @clear="handleClear"
  />
</template>

<script>
export default {
  name:"mInput",
  props: {
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    /* 是否显示切换密码图标 */
    showPassword: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    size: {
      type: String,
      default: 'small'
    },
    /* 是否显示输入字数统计，只在 type = "text" 或 type = "textarea" 时有效 */
    wordLimit: {
      type: Boolean,
      default: false
    },
    minlength: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: 12
    },
    /* 输入框头部图标 */
    prefixIcon: {
      type: String,
      default: ''
    },
    /* 输入框尾部图标 */
    suffixIcon: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 2
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    /* 验证类型 */
    validatorType: {
      type: Number,
      default: 0
    },
    /* 绑定值 */
    value: {
      type: [Number, String],
      default: null
    },
    change: {
      type: Function,
      default: function() {
        return
      }
    },
    blur: {
      type: Function,
      default: function() {
        return
      }
    },
    focus: {
      type: Function,
      default: function() {
        return
      }
    },
    clear: {
      type: Function,
      default: function() {
        return
      }
    }
  },
  data() {
    return {
      inputValue: this.value
    }
  },
  watch:{
    value(val){
      this.inputValue = val
    }
  },
  methods: {
    /* 验证输入类型 */
    inputChange(val) {
      const type = this.validatorType
      this.inputValue = String(this.inputValue)
      let reg = null
      switch (type) {
        case 1: // 只能输入正整数
          reg = /\D|^0/g
          break
        case 2: // 数字，小数点保留两位小数
          this.checkInput(val)
          break
        case 3: // 只能输入英文和数字
          reg = /[^\w\.\/]/ig
          break
        case 4: // 只能输入字母和汉字
          reg = /[\d]/g
          break
        case 5: // 只能输入字母
          reg = /[^a-zA-Z$]/g
          break
      }
      if (type !== 2) {
        this.inputValue = this.inputValue.replace(reg, '')
      }
      let newValue = this.inputValue

      if (typeof this.value === 'number') newValue = Number(newValue)
      else newValue = String(newValue)
      if (!newValue) newValue = null
      this.$emit('input', val) // 触发父组件的input事件
    },
    // 验证输入类型为2
    checkInput() {
      if (String(this.inputValue) === '00') {
        this.inputValue = '0'
      }
      this.inputValue = this.inputValue.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')
    },
    /* 仅在输入框失去焦点或用户按下回车时触发 */
    handleChange(val) {
      this.$emit('change', val)
    },
    /* 在 Input 获得焦点时触发 */
    handleFocus(event) {
      this.$emit('focus', event)
    },
    /* 在 Input 失去焦点时触发 */
    handleBlur(event) {
      this.$emit('blur', event)
    },
    handleClear() {
      this.$emit('clear', event)
    }
  }
}
</script>

<style>

</style>
